import React, { useState, useEffect } from "react";
import { onGetToken } from "../firebaseInit";
import Cookie from "js-cookie";

const Notifications = (props) => {
  const [isTokenFound, setTokenFound] = useState(false);

  // console.log("Token found", isTokenFound);

  useEffect(() => {
    let data;
    async function tokenFunc() {
      data = await onGetToken(setTokenFound);
      if (data) {
        console.log("Token is", data);
      }
      return data;
    }
    tokenFunc();
  }, [setTokenFound]);
  return <></>;
};
export default Notifications;
